import React from 'react';
import TextInput from './Common/TextInput';
import ajax from '../ajax';
import AlertSuccess from './Common/AlertSuccess';
import AlertError from './Common/AlertError';

import dictionary from '../dictionary';


class MdlEditChargeSend extends React.Component {
  state={
      info:'',
      minAmount:'',
      maxAmount:'',
      charges:'',
      chargeId:'',
      data:this.props.record
  }

  componentDidMount()
  {
      this.setState({
        minAmount:this.state.data.min.amount,
        maxAmount:this.state.data.max.amount,
        charges:this.state.data.charge.amount,
        chargeId:this.state.data.charge_id
      })
  }


  onChangeMin = (event) => {
    this.setState({minAmount: event.target.value});
  }

  onChangeMax = (event) => {
    this.setState({maxAmount: event.target.value});
  }

  onChangeCharge = (event) => {
    this.setState({charges: event.target.value});
  }

  onSave=async(event)=>{
    
    event.preventDefault();

    const {minAmount, maxAmount, charges}=this.state
   
    if(minAmount.length>0 && 
      maxAmount.length>0 && 
      charges.length>0)
    {

        const server_response=await ajax.updateSendCharges(this.state.chargeId, minAmount, maxAmount, charges);
        if(server_response.status==="OK")
        {
           this.setState({
             info:<AlertSuccess message={server_response.details[0]}/>
           })
           this.props.onFinish()
        }else{
          this.setState({
            info:<AlertError message={server_response.details[0]}/>
          })
        }

    }else{
      this.setState({
        info:<AlertError message={dictionary._completeFields}/>
      })
    }
  }

  render(){
    
      return (
        <div className="modal" id={"mdl-edit-send-charge" + this.props.id}>
        <div className="modal-dialog modal-dialog-scrollable" role="document">
            <div className="modal-content modal-content-demo">
                <div className="modal-header">
                    <h6 className="modal-title">Edit Send Charges</h6><button aria-label="Close" className="close" data-dismiss="modal" type="button"><span aria-hidden="true">&times;</span></button>
                </div>
                <div className="modal-body">
                            {this.state.info}
                            <form method="post" onSubmit={this.onSave}>
										
                                       
                                          <TextInput 
                                            label="Min amount"
                                            type="number"
                                            onChange={()=>this.onChangeMin}
                                            value={this.state.minAmount}
                                            />
    
                                            <TextInput 
                                                label="Max Amount"
                                                type="number"
                                                onChange={()=>this.onChangeMax}
                                                value={this.state.maxAmount}
                                                />

                                            <TextInput 
                                                label="Charges"
                                                type="number"
                                                onChange={()=>this.onChangeCharge}
                                                value={this.state.charges}
                                                />
                                    </form>
                                
                </div>
                <div className="modal-footer">
                    <input className="btn ripple btn-primary" type="button" value="Save Changes" onClick={this.onSave}/>
                    <input className="btn ripple btn-secondary" data-dismiss="modal" type="button" value="Close"/>
                </div>
            </div>
        </div>
    </div>
  )}
      
}

export default MdlEditChargeSend;